<template>
  <div id="top_payers" style="margin-top: 10px;" class="report_card">
  <b>Top Payers</b>:

  <b-list-group style="margin-top: 10px">
    <b-list-group-item v-for="payer in payers" v-bind:key="payer.account" class="paid_out">
      <AccountLink v-bind:account="payer.account" />: {{payer.num}} payments
    </b-list-group-item>
  </b-list-group>
  </div>
</template>

<script>
import AccountLink from '../../AccountLink.vue'

export default {
  name: 'MetricsActiveAccounts',

  components : {AccountLink},

  computed : {
    data : function(){
      return this.$store.state.report.data["top_payers"];
    },

    payers : function(){
      return this.data;
    },
  },
}
</script>

<style scoped>
#top_payers{
  padding: 10px;
}

.paid_out{
  border-left: 1px solid blue;
  margin-bottom: 2px;
}
</style>
